var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1096"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1096"
    },
    "bundlingPackage": "pricing-pages-ui-public-app",
    "bundlingPackageVersion": "static-1.11940",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};